import React, { useEffect } from "react"
import { useHistory } from "react-router-dom"
import { Helmet } from 'react-helmet'
import * as R from 'ramda'
import moment from 'moment'
import 'moment/locale/zh-tw'

import { connect } from 'react-redux'
import { getUser, getTransactionList } from '../actions/wall'
import { getGame } from '../actions/game'

import { Row, Col, Skeleton } from 'antd'

import dataemptyImg from '../assets/images/icon-empty-dataempty@3x.png'
import avatarImg from '../assets/images/image_userhead_36@3x.png'
import rewardImg from '../assets/images/icon-tag-prize@3x.png'
import freeImg from '../assets/images/icon-tag-free@3x.png'
import moneyImg from '../assets/images/icon-tag-money.png'

export function WallContent(props) {
    let history = useHistory()
    moment.locale('zh-tw')
    const { user, transactions, isNoUser, isloading } = props
    const { email, popUpState, setPopUpState } = props

    const defaultName = 'FitGames用戶'
    const defaultInfo = '尚無自我介紹'
    const openAppUrl = `https://fitgames.tw/applink`

    useEffect(() => {
        props.getUser(email)
    }, [])

    useEffect(() => {
        if (user.uid) {
            props.getTransactionList(user.uid)
        }        
    }, [user])

    useEffect(() => {
        if (isNoUser) {
            history.push('/pageNotFound')
        }
    })

    const handleFollow = () => {
        window.open(openAppUrl + `?type=13&email=${user.email}`, "_self")
    }

    const handlePopUp = (type, gid) => {
        setPopUpState({
            isOpen: !popUpState.isOpen,
            popUpType: type,
            gid: gid,
        })
    }

    const handleOpenGame = (gid) => {
        history.push(`/game?gid=${gid}`)
    }

    const getDate = (props) => {
        const dateLocal = moment(props * 1000).format('YYYY/MM/DD')
        return dateLocal
    }

    const getEndDays = (props) => {
        const endDays = moment(props * 1000).fromNow('d')
        return endDays
    }

    const GameContent = (props) => {
        const { transaction } = props

        return (
            <Row className="wall-transaction-game-frame">
                <img src={transaction.imgUrl} className="wall-transaction-game-img" alt="gameImage" />
                <p className="wall-transaction-game-time-font">
                    {moment().isBefore(transaction.startTime * 1000) ? `${getDate(transaction.startTime)} 競賽開始`
                        : moment().isBefore(transaction.endTime * 1000) ? `完賽倒數 ${getEndDays(transaction.endTime)}`
                            : `競賽結束`
                    }
                </p>

                <Col className="wall-transaction-game-content-frame">
                    <p className="wall-transaction-game-title">{transaction.title}</p>

                    <Row>
                        <Col span={1} className="wall-transaction-game-reward-info-frame">
                            <p className="wall-transaction-game-reward-info-font">{transaction.reward}</p>
                        </Col>

                        <Col span={1} className="wall-transaction-game-reward-tag-frame">
                            <img
                                src={transaction.rewardType === 0 ? moneyImg
                                    : transaction.rewardType === 1 ? rewardImg : freeImg}
                                className="wall-transaction-game-reward-tag-img"
                                alt="reward"
                            />
                        </Col>

                        <Col span={1} className="wall-transaction-game-reward-tag-text-frame">
                            <p className={transaction.rewardType === 0 ? "wall-transaction-game-reward-tag-font-money"
                                : transaction.rewardType === 1 ? "wall-transaction-game-reward-tag-font"
                                    : "wall-transaction-game-reward-tag-font-free"}
                            >
                                {transaction.rewardType === 0 ? "獎金賽"
                                    : transaction.rewardType === 1 ? "獎品賽"
                                        : "自由賽"}
                            </p>
                        </Col>

                    </Row>
                </Col>

            </Row>
        )
    }

    return (
        <div>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{user.nickname || defaultName} - FitGames</title>
                <meta name='description' content={user.info || defaultInfo} />
                <meta property='og:title' content={`${user.nickname || defaultName} - FitGames`} />
                <meta property='og:description' content={user.info || defaultInfo} />
                <meta property='og:image' content={user.imgUrl || avatarImg} />
            </Helmet>

            <Skeleton active avatar paragraph={{ rows: 16 }} loading={isloading}>
                {/* User Block */}
                <Row className="wall-user-frame">
                    <Row type="flex" align="middle">
                        <Col span={1} className="wall-user-icon-frame">
                            <img src={user.imgUrl || avatarImg} className="wall-user-icon" alt="avatar" />
                        </Col>

                        <Col span={1} className="well-user-title-frame">
                            <p className="wall-user-title">{user.nickname || defaultName}</p>
                        </Col>

                        {/* Open App */}
                        <Col span={1} className="wall-user-follow-frame" style={{ alignItems: "center" }}>
                            <button className="wall-user-follow-btn" onClick={() => handleFollow()}>
                                追蹤
                            </button>
                        </Col>

                        {/* Popup */}
                        <Col span={1} className="wall-user-follow-frame-popup" style={{ alignItems: "center" }}>
                            <button className="wall-user-follow-btn" onClick={() => handlePopUp("wall")}>
                                追蹤
                            </button>
                        </Col>
                    </Row>

                    <Row className="wall-user-info-frame">
                        <p>{user.info || defaultInfo}</p>
                    </Row>
                </Row>

                {/* Transaction Block */}
                <Row className="wall-transaction-title">
                    <p>進行中競賽</p>
                </Row>

                <Row type="flex">
                    {transactions.map((transaction, index) => (
                        <Col xs={{ span: 24 }} md={{ span: 12 }} className={index % 2 === 0 ? "wall-transaction-game-left" : "wall-transaction-game-right"} key={index}>
                            <button className="wall-transaction-game-btn" onClick={() => handleOpenGame(transaction.gid)}>
                                <GameContent transaction={transaction} />
                            </button>
                        </Col>
                    ))}
                </Row>

                {/* No transaction data */}
                <Row
                    type="flex"
                    justify="center"
                    align="middle"
                    className={R.isEmpty(transactions) ? "wall-transaction-empty-frame" : "web-hidden"}
                >
                    <Col className="wall-transaction-empty-position">
                        <img src={dataemptyImg} className="wall-transaction-empty-img" alt="empty" />
                        <p className="wall-transaction-font-frame">目前無進行中競賽</p>
                    </Col>
                </Row>

            </Skeleton>

        </div>

    )
}

const mapStateToProps = state => ({
    user: state.wall.user,
    transactions: state.wall.transactions,
    isNoUser: state.wall.isNoUser,
    isloading: state.wall.isloading,
})

const mapDispatchToProps = {
    getUser,
    getTransactionList,
    getGame,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(WallContent)